import { z } from 'zod';

/** Стоимость одного LLM-запроса совместимости (main / aspect / ask). Кэш — бесплатно. */
export const COMPATIBILITY_REQUEST_COST = 1;

export const COMPATIBILITY_ASPECTS = [
  'go_out',
  'friendship',
  'joint_venture',
  'conversation',
  'energy_balance',
  'hobby',
  'connection_points',
] as const;
export const CompatibilityAspect = z.enum(COMPATIBILITY_ASPECTS);
export type CompatibilityAspect = z.infer<typeof CompatibilityAspect>;

export const COMPATIBILITY_ASPECT_META: Record<CompatibilityAspect, { emoji: string; label: string }> = {
  go_out: { emoji: '🗺️', label: 'В какой обстановке вам легко рядом' },
  friendship: { emoji: '🤝', label: 'Что укрепляет ваше доверие, а что ломает' },
  joint_venture: { emoji: '💼', label: 'В каком деле вы раскроетесь и где столкнётесь' },
  conversation: { emoji: '🧠', label: 'Как вы слышите друг друга в разговоре' },
  energy_balance: { emoji: '⚡', label: 'Как вам сбалансировать разницу в темпе' },
  hobby: { emoji: '🧩', label: 'В каких занятиях ваша связка работает' },
  connection_points: {
    emoji: '🧭',
    label: 'Где у вас настоящее пересечение, а где ложное',
  },
};

export const CompatibilityStatus = z.enum([
  'ready',
  'missing_my_tests',
  'missing_their_tests',
  'missing_both_tests',
]);
export type CompatibilityStatus = z.infer<typeof CompatibilityStatus>;

export const CompatibilityStatusDto = z.object({
  status: CompatibilityStatus,
  targetUserName: z.string(),
  /** Есть ли у пары актуальный главный анализ (повторное открытие бесплатно). */
  hasFreshAnalysis: z.boolean(),
});
export type CompatibilityStatusDto = z.infer<typeof CompatibilityStatusDto>;

export const CompatibilityDetailDto = z.object({
  aspect: CompatibilityAspect,
  text: z.string().nullable(),
});
export type CompatibilityDetailDto = z.infer<typeof CompatibilityDetailDto>;

export const CompatibilityResultDto = z.object({
  mainText: z.string(),
  details: z.array(CompatibilityDetailDto),
  charged: z.boolean(),
});
export type CompatibilityResultDto = z.infer<typeof CompatibilityResultDto>;

export const GenerateCompatibilityInput = z
  .object({
    /** true — игнор кэша, новый LLM + списание 1⚡, wipe деталей. */
    force: z.boolean().optional().default(false),
  })
  // prefault, а не default: в Zod 4 `.default()` отдаёт значение как выходное,
  // не прогоняя через схему — пустое тело давало `{}` без `force: false`.
  .prefault({});
export type GenerateCompatibilityInput = z.infer<typeof GenerateCompatibilityInput>;

export const GenerateDetailInput = z.object({
  aspect: CompatibilityAspect,
});
export type GenerateDetailInput = z.infer<typeof GenerateDetailInput>;

export const GenerateDetailResultDto = z.object({
  text: z.string(),
  charged: z.boolean(),
});
export type GenerateDetailResultDto = z.infer<typeof GenerateDetailResultDto>;

export const AskCompatibilityInput = z.object({
  question: z.string().trim().min(1).max(500),
});
export type AskCompatibilityInput = z.infer<typeof AskCompatibilityInput>;

export const AskCompatibilityResultDto = z.object({
  text: z.string(),
  charged: z.boolean(),
});
export type AskCompatibilityResultDto = z.infer<typeof AskCompatibilityResultDto>;
